module.exports = __webpack_public_path__ + "static/img/frame.4f663ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/frame.jpg
// module id = xGfG
// module chunks = 1